import React, { useEffect } from 'react';
import { HashRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { App as AntdApp } from 'antd';
import AdminLayout from './layouts/AdminLayout';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Videos from './pages/Videos';
import Documents from './pages/Documents';
import Trades from './pages/Trades';
import Strategies from './pages/Strategies';
import Traders from './pages/Traders';
import ProfileConfig from './pages/ProfileConfig';
import VIPManagement from './pages/VIPManagement';
import PopupConfig from './pages/PopupConfig';
import VIPStrategyConfig from './pages/VIPStrategyConfig';
import ActivationCodes from './pages/ActivationCodes';
import Settings from './pages/Settings';
import api from './services/api';
import { AuthProvider, useAuth } from './contexts/AuthContext';

// Protected Route Component
const ProtectedRoute = ({ children }) => {
  const { isAuthenticated, loading } = useAuth();
  
  if (loading) {
    return <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>加载中...</div>;
  }
  
  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }
  
  return children;
};

function App() {
  // 动态加载网站名称并更新浏览器标题
  useEffect(() => {
    const loadSiteName = async () => {
      try {
        const response = await api.get('/settings/siteName');
        if (response.data.success && response.data.data) {
          document.title = response.data.data + ' - 管理后台';
        }
      } catch (error) {
        console.error('Failed to load site name:', error);
      }
    };
    loadSiteName();
  }, []);

  return (
    <AntdApp>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/login" element={<Login />} />
            <Route path="/" element={
              <ProtectedRoute>
                <AdminLayout />
              </ProtectedRoute>
            }>
              <Route index element={<Dashboard />} />
              <Route path="users" element={<Users />} />
              <Route path="videos" element={<Videos />} />
              <Route path="documents" element={<Documents />} />
              <Route path="trades" element={<Trades />} />
              <Route path="strategies" element={<Strategies />} />
              <Route path="traders" element={<Traders />} />
              <Route path="profile-config" element={<ProfileConfig />} />
              <Route path="vip" element={<VIPManagement />} />
              <Route path="vip-strategy" element={<VIPStrategyConfig />} />
              <Route path="activation-codes" element={<ActivationCodes />} />
              <Route path="popup" element={<PopupConfig />} />
              <Route path="settings" element={<Settings />} />
            </Route>
          </Routes>
        </Router>
      </AuthProvider>
    </AntdApp>
  );
}

export default App;

